export default __webpack_public_path__ + "fk-cp-zion/img/webpushchrome_fd5fb7.png";